import {
  deleteAdminOrganisationByOrganisationId,
  get_report_org_diskUsage,
  getAdminOrganisationByOrganisationId,
  getAxiosInstance,
  getDomain,
  putAdminOrganisationByOrganisationId
} from '@modv/sdk'
// eslint-disable-next-line no-unused-vars
import { Notification } from 'element-ui'
import BaseEntity from '../base-entity/index'

const baseEntity = new BaseEntity()

const state = {
  organisation: {
    clientId: null
  },
  orgReport: {},
  organisationDetailLoading: false,
  ...baseEntity.state
}
const getters = {
  ...baseEntity.getters
}
const mutations = {
  ...baseEntity.mutations,
  set_organisation_detail_loading(state, val) {
    state.organisationDetailLoading = val
  },
  GET_ORGANISATION: (state, res) => {
    state.organisation = res.data
    if (!state.organisation.brand) {
      state.organisation.brand = {}
    }
    if (state.organisation.clientId === undefined) {
      state.organisation.clientId = null
    }
  },
  UPDATE_ORGANISATION: (state, res) => {
    state.organisation = res.data
  },
  DELETE_ORGANISATION: (state, res) => {},
  ON_CHANGE_MODAL(state, res) {
    state.showDeleteModal = false
    state.showModal = res.visible
  },
  GET_ORG_REPORT(state, data) {
    state.orgReport = data
  },
  UPDATE_CLIENT_ID(state, id) {
    state.organisation.clientId = id
    state.organisation.clientSecrets = [...state.organisation.clientSecrets]
  },
  onChangeModal(state, res) {
    state.showModal = res.visible
  }
}
const actions = {
  ...baseEntity.actions,
  async delete({ commit, dispatch }, params) {
    dispatch(
      'home/removeOrganisation',
      {
        organisationId: params.organisationId
      },
      {
        root: true
      }
    )

    commit(
      'DELETE_ORGANISATION',
      await deleteAdminOrganisationByOrganisationId({
        organisationId: params.organisationId
      })
    )
  },
  async updateOrganisation({ commit, dispatch }, { organisationId, name, brand, clientId, clientSecrets = [] }) {
    commit('set_organisation_detail_loading', true)
    const res = await putAdminOrganisationByOrganisationId({
      organisationId,
      $body: {
        organisationId,
        name,
        brand,
        clientId,
        clientSecrets
      }
    })
    commit('UPDATE_ORGANISATION', res)
    commit('set_organisation_detail_loading', false)
    if (res.status === 200) {
      Notification.success('Organisation updated.')
      dispatch(
        'home/updateOrganisation',
        {
          organisationId: organisationId,
          name: name
        },
        {
          root: true
        }
      )
    } else {
      Notification.error('Something went wrong.')
    }
  },
  async get({ commit }, params) {
    commit('set_organisation_detail_loading', true)
    commit(
      'GET_ORGANISATION',
      await getAdminOrganisationByOrganisationId({
        organisationId: params.organisationId
      })
    )
    const organisationId = params.organisationId
    const { data } = await get_report_org_diskUsage({ organisationId })
    commit('GET_ORG_REPORT', data)
    commit('set_organisation_detail_loading', false)
  },
  async getClientId({ commit }, { organisationId }) {
    const { data } = await getAxiosInstance().get(`${getDomain()}/admin/organisation/${organisationId}/clientId`)
    commit('UPDATE_CLIENT_ID', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
